import { atom } from "recoil";

const isLanguageAtom = atom({
  key: "isLanguageState",
  default: "",
});

export default isLanguageAtom;
